import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GuidanceService } from 'src/app/admin/services/guidance/guidance.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
  selector: 'app-edit-guidance-card',
  templateUrl: './edit-guidance-card.component.html',
  styleUrls: ['./edit-guidance-card.component.scss'],
  standalone: false
})
export class EditGuidanceCardComponent implements OnInit {


  BaseUrl = ''
  constructor(
    private userdata: UserdataService,
    private spinner: NgxSpinnerService,
    private guidanceService: GuidanceService,
    private router: ActivatedRoute,
    private toast: ToastrService,
    private route: Router,
    private trusturl: DomSanitizer,
    @Inject('BASE_IMAGE_URL') _imageurl: any
  ) {
    this.BaseUrl = _imageurl
  }

  data: any = '';
  id: any = '';

  ngOnInit(): void {
    this.id = this.router.snapshot.paramMap.get('id')
    this.getDataById()
    this.getSanitizeUrl()
  }

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    _id: new UntypedFormControl('', Validators.required),
    name: new UntypedFormControl('', Validators.required),
    guidanceCard_image: new UntypedFormControl('', Validators.required),
  });

  cardImage: any

  getDataById() {
    this.spinner.show()
    this.guidanceService.getSingleGuidanceCard({ _id: this.id }).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.cardImage = res.data.image
        this.formGroup.patchValue({ _id: res.data._id });
        this.formGroup.patchValue({ name: res.data.name });
        this.formGroup.patchValue({ guidanceCard_image: res.data.guidanceCard_image });
      },
      err => {
        this.spinner.hide()
        this.route.navigateByUrl('/admin/guidance-card/list')
      }
    )
  }

  getSanitizeUrl() {
    return this.trusturl.bypassSecurityTrustUrl(this.BaseUrl + this.cardImage)
  }


  get f() {
    return this.formGroup.controls
  }

  uploadImage(event: any) {
    this.formGroup.patchValue({ 'guidanceCard_image': event.target.files[0] });
  }
  /* ***********
  Update  Category
 *********** */

  public submit() {
    this.spinner.show()
    let data = new FormData();
    data.append('_id', this.formGroup.value._id ?? '');
    data.append('name', this.formGroup.value.name ?? '');
    data.append('guidanceCard_image', this.formGroup.value.guidanceCard_image ?? '');
    this.guidanceService.updateGuidanceCard(data).subscribe(
      (res: any) => {
        if (res.success) {
          this.spinner.hide()
          this.toast.success(res.message, 'Success')
          this.route.navigateByUrl('/admin/guidance-card/list')
        }
        else {
          this.spinner.hide()
          this.toast.error(res.message)
        }
      },
      err => {
        this.spinner.hide()
        this.toast.error('Something went wrong!', 'Error');
      })
  }

}
